import Inject from '@/modules/shared/domain/dependency_injection/inject';
import Query from '@/modules/shared/domain/services/query';
import { StepEntity } from '../../domain/entities';
import { StateManager } from '../../domain/state/state-manager';
import TYPES from '../../types';

export default class GetOnboardingCurrentStepQuery extends Query<Promise<StepEntity>> {
  @Inject(TYPES.ONBOARDING_STATUS_STATE_MANAGER)
  private readonly state_manager!: StateManager;

  internalExecute(): Promise<StepEntity> {
    const prioritySteps = [
      'new_client_was_added',
      'sign_up',
      'verify_nip',
      'identity_verification',
      'upload_documents',
      'personal_information',
      'tax_information',
      'financial_information',
      'bank_information',
      'beneficiaries',
      'confirmation',
      'validation_process',
      'sign_documents',
      'initial_contribution',
    ].reverse();

    let matched_step = null;

    for (let i = 0; i < prioritySteps.length; i++) {
      const stepName = prioritySteps[i];
      matched_step = this.state_manager.state.steps.find((item) => item.current_step === stepName);
      if (matched_step) break;
    }

    const current_step = (matched_step) || this.state_manager.state.steps[0];

    return Promise.resolve(current_step);
  }
}
